import React from 'react';

function ClientMenuModal({ onClose, items }) {
    if (!items?.length) return null;

    return (
        <div className="modal_overlay" onClick={onClose}>
            <div
                className="modal_window"
                onClick={(e) => e.stopPropagation()}
            >
                {items.map((item) => (
                    <div
                        key={item.label}
                        className="modal_item"
                        onClick={() => {
                            onClose();
                            item.onClick();
                        }}
                    >
                        <span className={item.danger ? 'delete_text' : undefined}>{item.label}</span>
                        {item.icon}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ClientMenuModal;
